<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">{{ lang.get("financial.prognosis.prognosis") }} {{ getSpanningYearsHeader }}</h2>
                <div class="box-tools">
                    <button
                        class="btn btn-default"
                        @click="exportToPdf()"
                        v-tooltip="'Exporteer naar PDF'"
                    >
                        <i class="mdi mdi-file-pdf-box"></i>
                    </button>
                    <div class="btn-group btn-group-xs">
                        <button class="btn btn-default" @click="moveBackwardsYear()" data-tooltip="tooltip" title="Een jaar terug"><i class="fa fa-angle-double-left"></i></button>
                        <button class="btn btn-default" @click="moveBackwards()" data-tooltip="tooltip" title="Een maand terug"><i class="fa fa-angle-left"></i></button>
                        <button class="btn btn-default" @click="moveReset()" v-show="isResetable" data-tooltip="tooltip" title="Terugzetten">Reset</button>
                        <button class="btn btn-default" @click="moveForward()" data-tooltip="tooltip" title="Een maand vooruit"><i class="fa fa-angle-right"></i></button>
                        <button class="btn btn-default" @click="moveForwardYear()" data-tooltip="tooltip" title="Een jaar vooruit"><i class="fa fa-angle-double-right"></i></button>
                    </div>
                </div>
            </div>
            <div class="box-body no-padding table-responsive">
                <table class="table table-striped table-hover table-condensed table-bordered centered-table-headers" id="prognosis-table">
                    <thead>
                        <tr>
                            <th rowspan="2">&nbsp;</th>
                            <th v-for="(colspan, year) in getSpanningYears" :colspan="colspan">{{ year }}</th>
                        </tr>
                        <tr>
                            <th v-for="(n, addmonth) in 12" :class="{'col-sm-1 text-right':true,'info':currentMonth(addmonth)}">{{ moment(startperiod).add(addmonth, "month").format("MMM") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="project in projects">
                            <td style="white-space:nowrap">{{ project.name }}</td>
                            <td v-for="(n, addmonth) in 12" :class="{'text-right':true,'info':currentMonth(addmonth)}">
                                <span v-if="hasEntry(project, n)" style="display:block;">{{ getPrognosis(project) | toCurrency(false) }}</span>
                                <span v-else>&ndash;</span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="text-right text-bold">{{ lang.get("global.total") }}:</td>
                            <td v-for="(n, addmonth) in 12" :class="{'text-right':true,'info':currentMonth(addmonth)}" style="font-weight:bold;">{{ calcMonth(n) | toCurrency(false) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="overlay" v-show="isLoading">
                <i class="fa fa-refresh fa-spin" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-sm-offset-2">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get("global.projects") }}</h2>
                        <div class="box-tools">
                            <div class="btn-group btn-group-xs">
                                <button class="btn btn-info"
                                    type="button"
                                    @click="refresh()"
                                >
                                    <i class="fa fa-refresh" />
                                </button>
                                <button class="btn btn-primary"
                                    type="button"
                                    @click="selectProjects()"
                                >
                                    <i class="fa fa-plus" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="box-body no-padding">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th class="col-sm-3">{{ lang.get("global.project") }}</th>
                                    <th class="col-sm-2">{{ lang.get("financial.prognosis.expectedsenddate") }}</th>
                                    <th class="col-sm-1">{{ lang.get("global.duration") }}</th>
                                    <th class="col-sm-2">{{ lang.get("financial.prognosis.fee") }}</th>
                                    <th class="col-sm-1">Betaaltermijn</th>
                                    <th class="col-sm-2">%</th>
                                    <th class="col-sm-1">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="projects.length === 0">
                                    <td colspan="7">{{ lang.get("financial.prognosis.noyearentries") }}</td>
                                </tr>
                                <tr v-for="project in projects">
                                    <td>{{ project.name }}</td>
                                    <td>
                                        <monthly-picker
                                            dateFormat="MM-YYYY"
                                            inputClass="text"
                                            placeHolder="Selecteer"
                                            v-model="project.startdate"
                                            class="monthlypickerbottom"
                                            :min="startOfCurrentYear"
                                        />
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-center" v-model="project.duration" style="padding:1px 2px;" />
                                    </td>
                                    <td>
                                        <money v-model="project.fee" v-bind="money" class="form-control" style="padding:1px 2px;text-align:right;" />
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-center" v-model="project.paymentterm" style="padding:1px 2px;" />
                                    </td>
                                    <td>
                                        <v-select
                                            v-model="project.percentage"
                                            :options="defaultPercentage"
                                            :clearable="false"
                                            :pushTags="true"
                                            :taggable="true"
                                            :reduce="option => parseInt(option.label)"
                                        >

                                        </v-select>


<!--                                        <select class="form-control text-center" v-model="project.percentage">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="90">90</option>
                                            <option value="100">100</option>
                                        </select>-->
                                    </td>
                                    <td class="text-right">
                                        <button class="btn btn-danger btn-xs" type="button"
                                            @click="detachProject(project)"
                                        ><i class="fa fa-times" /></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="box-body text-right">
                        <button class="btn btn-primary"
                            :disabled="!canSubmit"
                            @click="updateData"
                        >Opslaan</button>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin" />
                    </div>
                </div>
            </div>
        </div>
        <project-select
            :excluded="selectedProjectUuids"
            @selected-projects="addSelectedProjects"
        />
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import MonthlyPicker from 'vue-monthly-picker';
import {Money} from 'v-money';
import vSelect from 'vue-select';
import Hub from '../../Hub';
import axios from 'axios';
import ProjectSelect from '../Common/ProjectSelect';
import Lang from '../../Lang';
import jsPDF from "jspdf";

export default {

    components: {
        MonthlyPicker,
        Money,
        vSelect,
        ProjectSelect,
    },

    computed: {

        ...mapGetters([
            "isLoading",
        ]),

        canSubmit() {
            return this.posting === false;
        },

        defaultPercentage() {
            return [
                {label:5, value:5},
                {label:10, value:10},
                {label:30, value:30},
                {label:50, value:50},
                {label:90, value:90},
                {label:100, value:100},
            ]
        },

        defaultStartperiod() {
            return moment().startOf("month").subtract(3, "month");
        },

        getPercentageOptions() {
            let options = [];
            for (let i = 0; i <= 100; i = i + 5) { options.push(i); }
            return options;
        },

        getSpanningYears() {
            let years = {};
            for (let i = 0; i < 12; i++) {
                let year = moment(this.startperiod).add(i, "month").format("YYYY");
                if (!years[year]) {
                    years[year] = 0;
                }
                years[year]++;
            }
            return years;
        },

        getSpanningYearsHeader() {
            return Object.keys(this.getSpanningYears).join(' - ');
        },

        getUpdateData() {
            let projects = [];
            this.projects.forEach(proj => {
                if (typeof proj.startdate !== "string") {
                    proj.startdate = moment(proj.startdate).format("YYYY-MM-DD");
                }
                projects.push(proj);
            });
            return {projects: projects};
        },

        isResetable() {
            if (this.startperiod === null) {
                return false;
            }
            return this.startperiod.format() !== this.defaultStartperiod.format();
        },

        selectedProjectUuids() {
            let uuids = [];
            this.projects.forEach(project => uuids.push(project.project_uuid));
            return uuids;
        },

        startOfCurrentYear() {
            return moment(this.startperiod,"YYYY").startOf("year");
        },

    },

    created() {
        this.updateData = debounce(this.updateData, 300);
    },

    data() {
        return {
            lang:Lang,
            moment:moment,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            posting:false,
            projects: [],
            showProjects:true,
            startperiod:null,
        }
    },

    destroyed() {
        Hub.$off("prognosis-destroy", this.destroyPrognosis);
    },

    methods: {

        ...mapActions([
            "parseData",
            "setLoading",
        ]),

        addSelectedProjects(projects) {
            // Loop given projects
            projects.forEach(newproject => {
                this.projects.push({
                    uuid:null,
                    project_uuid:newproject.uuid,
                    name:newproject.name,
                    startdate:moment(),
                    duration:1,
                    fee:0,
                    percentage:0,
                    paymentterm:31,
                })
            });
        },

        calcMonth(month) {
            let total = 0;
            this.projects.forEach(pr => {
                if (this.hasEntry(pr, month)) {
                    total += this.getPrognosis(pr);
                }
            });
            return total;
        },

        currentMonth(addmonth){
            return moment().isBetween(
                moment(this.startperiod).add(addmonth, "month").startOf("month"),
                moment(this.startperiod).add(addmonth, "month").endOf("month")
            );
        },

        destroyPrognosis(project) {
            // Drop the project from the object
            this.projects.splice(this.projects.findIndex((pr) => {
                return pr.uuid === project.uuid;
            }), 1);
            // Delete the entry
            axios.delete(project.paths.destroy);
        },

        detachProject(project) {
            // Show the removal modal
            Hub.$emit("show-remove-confirmation-modal", Lang.get("financial.prognosis.delete.header"), Lang.get("financial.prognosis.delete.body", {"project":project.name}), "prognosis-destroy", project);
        },

        exportToPdf() {
            let doc = new jsPDF({orientation:'landscape'});
            let style = {fontSize:7,halign:'right'};
            doc.autoTable({
                html:'#prognosis-table',
                bodyStyles: style,
                footStyles: style,
            });
            doc.save('prognosis-' + moment().format('YYYY-MM-DD-HH-mm') + '.pdf');
        },

        getEntries() {
            axios.get(this.indexUri, {params: { startperiod: this.startperiod.format("YYYY-MM-DD") }})
                .then(response => {
                    // Store projects
                    this.projects = response.data.data;
                    // Set loading
                    this.setLoading(false);
                });
        },

        getPrognosis(project) {
            if (project.duration === 0 || null === project.startdate || project.percentage === 0) { return 0; }
            return (project.fee / project.duration) * project.percentage;
        },

        hasEntry(project, addmonth) {
            // Check startdate
            if (null === project.startdate || project.percentage === 0) {
                return false;
            }
            // Set startdate
            let startdate = moment(project.startdate).add(1, "day");   // Moment utilizes timezones and since we only get the first day of a month, without adding this single day, we might end up in the wrong month...
            // Calc enddate
            let enddate = moment(startdate).add(project.duration, "month");
            // Get now
            let now = moment(this.startperiod).add(addmonth, "month");
            // Use the isBetween method
            return now.isBetween(startdate, enddate);
        },

        move(newstartperiod) {
            this.loading = true;
            this.tasks = [];
            this.startperiod = newstartperiod.startOf("month");
            this.getEntries();
        },

        moveBackwardsYear() {
            this.move(moment(this.startperiod).add(12,"hours").subtract(1, "year"));
        },

        moveBackwards() {
            this.move(moment(this.startperiod).add(12,"hours").subtract(1, "month"));
        },

        moveForward() {
            this.move(moment(this.startperiod).add(12,"hours").add(1, "month"));
        },

        moveForwardYear() {
            this.move(moment(this.startperiod).add(12,"hours").add(1, "year"));
        },

        moveReset() {
            this.move(this.defaultStartperiod);
        },

        refresh() {
            this.setLoading(true);
            this.getEntries();
        },

        selectProjects() {
            Hub.$emit("open-project-selector");
        },

        setStartperiod(startperiod) {
            this.startperiod = startperiod;
        },

        validPrognosis(prognosis){
            return prognosis.startdate !== null;
        },

        updateData() {
            let projects = [];
            this.projects.forEach(prog => {
                if (this.validPrognosis(prog)) { projects.push(prog); }
            });
            // Fire the update action if the projects count is larger than 0
            if (projects.length > 0 && this.posting === false) {
                this.posting = true;
                axios.patch(this.updateUri, this.getUpdateData)
                .then(response => {
                    let uuids = response.data.data;
                    let identifier = 0;
                    if (uuids.length > 0) {
                        // loop the projects
                        this.projects.forEach(prognosis => {
                            if (prognosis.uuid === null && this.validPrognosis(prognosis)) {
                                if (uuids[identifier]) {
                                    prognosis.uuid = uuids[identifier];
                                    identifier++;
                                }
                            }
                        })
                    }
                    this.$snotify.success('De prognoses zijn opgeslagen');
                })
                .catch(() => this.$snotify.error(''))
                .finally(() => this.posting = false);
            }
        },
    },

    mounted() {
        this.setStartperiod(this.defaultStartperiod);
        this.getEntries();
        this.$nextTick(function () {
            Hub.$on("prognosis-destroy", this.destroyPrognosis);
        }.bind(this));
        this.parseData();
    },

    name:"BusinessPrognosis",

    props: {
        indexUri: { required:true },
        updateUri: { required:true },
    },
}

</script>

<style>

.vue-monthly-picker .month-picker-wrapper {
    min-width:0 !important;;
}

.vue-monthly-picker .date-popover {
    min-width:200px !important;
}

div.v-select {
    background-color:#fff;
}

</style>
